import { Link } from 'react-router-dom';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';

export function FeaturedPosts() {
  const featuredPosts = [
    {
      title: "The Future of AI in Personal Productivity",
      description: "How artificial intelligence is revolutionizing the way we work and live.",
      category: "AI",
      slug: "future-ai-productivity",
      date: "March 15, 2024",
      image: "https://images.unsplash.com/photo-1677442136019-21780ecad995?w=500&h=300&fit=crop&crop=focalpoint"
    },
    {
      title: "Building a Startup in 2024: Lessons Learned",
      description: "Key insights from my journey in the startup ecosystem.",
      category: "Startups",
      slug: "startup-lessons-2024",
      date: "March 10, 2024",
      image: "https://images.unsplash.com/photo-1559136555-9303baea8ebd?w=500&h=300&fit=crop&crop=focalpoint"
    },
    {
      title: "Digital Nomad Life: Working from Bali",
      description: "My experience working remotely from paradise and the challenges it brings.",
      category: "Traveling",
      slug: "digital-nomad-bali",
      date: "March 5, 2024",
      image: "https://images.unsplash.com/photo-1537953773345-d172ccf13cf1?w=500&h=300&fit=crop&crop=focalpoint"
    }
  ];

  return (
    <section className="py-16">
      <div className="container mx-auto px-4">
        <div className="flex justify-between items-center mb-12">
          <h2 className="text-3xl font-bold">Featured Posts</h2>
          <Link to="/blog">
            <Button variant="outline">
              View All Posts
            </Button>
          </Link>
        </div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {featuredPosts.map((post) => (
            <Card key={post.slug} className="hover:shadow-lg transition-shadow overflow-hidden">
              <div className="aspect-video overflow-hidden">
                <img 
                  src={post.image} 
                  alt={post.title}
                  className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
                />
              </div>
              <CardHeader>
                <div className="text-sm text-primary font-medium mb-2">
                  {post.category}
                </div>
                <CardTitle className="line-clamp-2">
                  <Link to={`/blog/${post.slug}`} className="hover:underline">
                    {post.title}
                  </Link>
                </CardTitle>
                <CardDescription className="line-clamp-3">
                  {post.description}
                </CardDescription>
              </CardHeader>
              <CardContent>
                <div className="flex justify-between items-center">
                  <span className="text-sm text-muted-foreground">
                    {post.date}
                  </span>
                  <Link to={`/blog/${post.slug}`}>
                    <Button variant="ghost" size="sm">
                      Read More
                    </Button>
                  </Link>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
}